import { render } from "./shortcutMenu.vue?vue&type=template&id=274da7ce&scoped=true"
import script from "./shortcutMenu.vue?vue&type=script&lang=js"
export * from "./shortcutMenu.vue?vue&type=script&lang=js"

import "./shortcutMenu.vue?vue&type=style&index=0&id=274da7ce&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274da7ce"]])

export default __exports__